import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import { FormInstance } from 'antd/lib/form';
import { ProposalListResponse } from 'services/proposal';
import { findFinCTByAnyRefOrStatusOrDate } from 'services/fincontract';

export type ContractListSelectProps = SelectProps<any> & {
  tpreference?: string;
  tpidsupplier?: number;
  tpidbroker?: number;
  form?: FormInstance;
  fieldName?: string;
  currcode?: string;
};

const ContractListSelect = ({
  tpreference,
  tpidsupplier,
  tpidbroker,
  form,
  fieldName,
  currcode,
  ...props
}: ContractListSelectProps) => {
  const { data, isFetching: loadingCon } = useQuery(
    ['findFinCTByAnyRefOrStatusOrDate', tpreference, tpidsupplier , tpidbroker],
    () =>
      findFinCTByAnyRefOrStatusOrDate({
        clientname: '',
        branchid: '' as any,
        brokername: '',
        ctphase: '',
        marketingid: '' as any,
        network: '',
        offerid: '' as any,
        propreference: '',
        tprefbroker: '',
        ctstatus: '',
        datemax: '',
        datemin: '',
        ctreference: '',
        prcode: '',
        clientreference: tpreference ?? '',
        tpidbroker: tpidbroker ?? ('' as any),
        tpidsupplier: tpidsupplier ?? ('' as any),
      }).then((res) => res.list)
  );

  return (
    <Select
      {...props}
      showSearch
      optionFilterProp="children"
      filterOption={(input: any, option: any) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onSelect={
        props.onSelect
          ? props.onSelect
          : (ctrid) => {
              form?.setFieldsValue({
                [fieldName ? fieldName : 'ctreference']: data?.find(
                  (contract) => contract.ctrid === ctrid
                )?.ctreference,
                ctrid: ctrid,
              });
            }
      }
      loading={loadingCon}
    >
      {data?.map((contract: ProposalListResponse,index:number) => (
        <Select.Option value={contract.ctrid} key={index}>
          {contract.ctreference + ' - ' + contract.ctdescription + ' -- ' + index}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ContractListSelect;
